export class candidatureRequestHorsParcours {
  constructor(
    public submissionDate: Date,
    public conditionsAccepted: boolean,
    public firstname: string,
    public lastname: string,
    public birthDate: Date,
    public age: number,
    public selectedSexe: string,
    public phoneNumber: string,
    public isWhatsApp: boolean,
    public whatsAppNumber: string,
    public email: string,
    public confirmEmail: string,
    public selectedCountry: string,
    public selectedRightNationality: string,
    // public professionnalSituation: string,
    public professionnalSituation: string[],
    public selectedDiplome: string,
    public selectedRegion: string,
    public inHandicapSituation: boolean, //no use
    public handicapSituations: string[],
    public certificateId: string,
    public yourProject: string,
    public phoneCode: string,
    public appelCloseDate: string,
    public cohort: string,
    public selectedSituation: string,
    // public isValidated: boolean,
    public isSubmitted: boolean,
    public paramValue?: string,
    public selectedZone?: string | null,
    public typeAffectation?: string | null,
    public nomAffectation?: string | null
  ) { }
}
